import { Box } from "@mui/material";
import { SimpleList, TextField, type SimpleListProps } from "react-admin";
import { SatisfactionField, UserIcon } from "../../components";
import { type OrderDetail } from "../../models";

export const ReviewSimpleList = (props: SimpleListProps): JSX.Element => (
    <SimpleList<OrderDetail>
        empty={<></>}
        sx={{ width: "100%", "& .MuiListItem-root": { borderBottom: "thin solid var(--mui-palette-divider)" } }}
        primaryText={() => (
            <Box sx={{ display: "flex" }}>
                <TextField<OrderDetail> source="name" sx={{ flex: 1 }} variant="h6" />
                <SatisfactionField source="satisfaction" disabled />
            </Box>
        )}
        secondaryText={<TextField<OrderDetail> source="review" />}
        leftAvatar={r => (
            <>
                <UserIcon
                    image={{
                        src: r.image,
                        title: r.name,
                    }}
                />
            </>
        )}
        {...props}
    />
);
